import React, { useState, useEffect } from 'react';
import { useAuth } from '../AuthContext';
import { getEmployeeInfo } from '../api';
import { Header, Loader } from '../components';
import { IconUser, IconLogout } from '../Icons';
import config from '../config';

const LogoutScreen = ({ navigate }) => {
  const { courierId, organizationId, logout } = useAuth();
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getEmployeeInfo()
      .then((res) => {
        if (res.displayName) {
          setName(res.displayName);
        } else if (res.firstName) {
          setName(`${res.firstName} ${res.lastName || ''}`.trim());
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [courierId, organizationId]);

  const handleLogout = () => {
    logout();
    navigate('login');
  };

  return (
    <>
      <Header
        title="Профиль"
        onBack={() => navigate('list')}
      />
      <div className="screen">
        <div className="logout-screen">
          {loading ? (
            <Loader />
          ) : (
            <div className="courier-info-card">
              <div className="courier-avatar">
                <IconUser />
              </div>
              <div>
                <div style={{ fontSize: 12, color: '#888', marginBottom: 4 }}>Курьер</div>
                <div className="courier-name">{name || 'Нет данных'}</div>
              </div>
            </div>
          )}

          <button className="btn btn-danger" onClick={handleLogout}>
            <IconLogout /> Выйти из аккаунта
          </button>

          <button className="btn btn-outline" onClick={() => navigate('list')}>
            Перейти к доставкам
          </button>
        </div>
        <div className="version-tag">v{config.VERSION}</div>
      </div>
    </>
  );
};

export default LogoutScreen;
